export default __webpack_public_path__ + "static/media/LTC.790b7830.svg";